'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishInitialMessage = publishInitialMessage;
exports.publishChatMessage = publishChatMessage;
exports.publishOfflineMessage = publishOfflineMessage;
exports.republishMessage = republishMessage;
exports.publishLastSeenMessage = publishLastSeenMessage;

var _pubNubMessageSelectors = require('conversations-core/selectors/pubNubMessageSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _OutgoingMessageActions = require('conversations-core/actions/OutgoingMessageActions');

var _SenderTypes = require('conversations-schema/constants/SenderTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function publishMessageToConversation(_ref) {
  var channel = _ref.channel,
      message = _ref.message;

  return function (dispatch) {
    dispatch((0, _ConversationsActions.addMessageToConversation)({ channel: channel, message: message }));
    dispatch((0, _OutgoingMessageActions.enqueueOutgoingMessage)({ channel: channel, message: message }));
  };
}

function publishInitialMessage() {
  return function (dispatch, getState) {
    var _metadata;

    var channel = getState().currentChannel;

    var message = (0, _PubNubMessageFactory.buildUnpublishedMessage)({
      metadata: (_metadata = {}, _defineProperty(_metadata, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.INITIAL_MESSAGE), _defineProperty(_metadata, 'text', (0, _widgetDataSelectors.getInitialMessageText)(getState())), _defineProperty(_metadata, 'from', _RoleTypes2.default.REP), _metadata),
      senderId: (0, _widgetDataSelectors.getResponderUserId)(getState()),
      senderType: _SenderTypes.AGENT
    });

    dispatch(publishMessageToConversation({ channel: channel, message: message }));
  };
}

function publishChatMessage(_ref2) {
  var text = _ref2.text,
      richText = _ref2.richText,
      quickReply = _ref2.quickReply;

  return function (dispatch, getState) {
    var _metadata2;

    var channel = getState().currentChannel;

    var message = (0, _PubNubMessageFactory.buildUnpublishedMessage)({
      metadata: (_metadata2 = {}, _defineProperty(_metadata2, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.CHAT_MESSAGE), _defineProperty(_metadata2, 'from', (0, _pubNubMessageSelectors.getClientRole)(getState())), _defineProperty(_metadata2, 'richText', richText), _defineProperty(_metadata2, 'text', text), _defineProperty(_metadata2, 'quickReply', quickReply), _defineProperty(_metadata2, 'url', (0, _pubNubMessageSelectors.getMessageUrl)(getState())), _defineProperty(_metadata2, 'welcomeMessageId', (0, _pubNubMessageSelectors.getMessageId)(getState())), _metadata2),
      senderId: (0, _pubNubMessageSelectors.getSenderId)(getState()),
      senderType: (0, _pubNubMessageSelectors.getSenderType)(getState())
    });

    dispatch(publishMessageToConversation({ channel: channel, message: message }));
  };
}

function publishOfflineMessage(_ref3) {
  var text = _ref3.text,
      richText = _ref3.richText;

  return function (dispatch, getState) {
    var _metadata3;

    var channel = getState().currentChannel;

    var message = (0, _PubNubMessageFactory.buildUnpublishedMessage)({
      metadata: (_metadata3 = {}, _defineProperty(_metadata3, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.OFFLINE), _defineProperty(_metadata3, 'from', (0, _pubNubMessageSelectors.getClientRole)(getState())), _defineProperty(_metadata3, 'richText', richText), _defineProperty(_metadata3, 'text', text), _defineProperty(_metadata3, 'url', (0, _pubNubMessageSelectors.getMessageUrl)(getState())), _defineProperty(_metadata3, 'welcomeMessageId', (0, _pubNubMessageSelectors.getMessageId)(getState())), _metadata3),
      senderId: (0, _pubNubMessageSelectors.getSenderId)(getState()),
      senderType: (0, _pubNubMessageSelectors.getSenderType)(getState())
    });

    dispatch(publishMessageToConversation({ channel: channel, message: message }));
  };
}

function republishMessage(message) {
  return function (dispatch, getState) {
    var channel = getState().currentChannel;
    var updatedMessage = (0, _PubNubMessageFactory.buildUnpublishedMessage)(message);
    dispatch((0, _OutgoingMessageActions.enqueueOutgoingMessage)({ channel: channel, message: updatedMessage }));
    dispatch((0, _ConversationsActions.updateMessageInConversation)({ updated: updatedMessage, channel: channel, message: message }));
  };
}

function publishLastSeenMessage(_ref4) {
  var channel = _ref4.channel,
      timestamp = _ref4.timestamp;

  return function (dispatch, getState) {
    var _metadata4;

    var message = (0, _PubNubMessageFactory.buildUnpublishedMessage)({
      metadata: (_metadata4 = {}, _defineProperty(_metadata4, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.LAST_SEEN), _defineProperty(_metadata4, 'from', (0, _pubNubMessageSelectors.getClientRole)(getState())), _metadata4),
      senderId: (0, _pubNubMessageSelectors.getSenderId)(getState()),
      senderType: (0, _pubNubMessageSelectors.getSenderType)(getState()),
      timestamp: timestamp
    });

    dispatch(publishMessageToConversation({ channel: channel, message: message }));
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/PublishActions.js
// module id = 114
// module chunks = 0 1